import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const MAX_BARS = 8;
const TOOLTIP_STYLE = { fontSize: 11, fontFamily: 'Jost', borderRadius: 8, border: '1px solid #F5E6CC' };

export default function CountryChart({ countries }) {
  const rows = countries.slice(0, MAX_BARS);
  return (
    <div className="bg-white rounded-lg border border-saffron-100/50 shadow-card-lift p-5" data-testid="country-chart">
      <h3 className="font-display text-sm font-bold text-earth-dark mb-4">Top Markets: Inquiries vs Won Orders</h3>
      <ResponsiveContainer width="100%" height={Math.max(160, rows.length * 38)}>
        <BarChart data={rows} layout="vertical" margin={{ top: 0, right: 10, left: 10, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#F5E6CC" horizontal={false} />
          <XAxis type="number" allowDecimals={false} tick={{ fontSize: 9, fill: '#8B7355' }} />
          <YAxis type="category" dataKey="country" width={120} tick={{ fontSize: 10, fill: '#5C4A32' }} />
          <Tooltip contentStyle={TOOLTIP_STYLE} cursor={{ fill: '#FFF8ED' }} />
          <Legend wrapperStyle={{ fontSize: 10, fontFamily: 'Jost' }} />
          <Bar dataKey="inquiries" name="Inquiries" fill="#D4870A" radius={[0, 4, 4, 0]} barSize={12} />
          <Bar dataKey="won" name="Won orders" fill="#10B981" radius={[0, 4, 4, 0]} barSize={12} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
